import Axios from "../helper/appConfig";

export const getSelectRoomList = async (branchId,facilityids,checkInDate,checkOutDate) => {
    const body = {
      id: "63e4885803f7970f472cfc94",
      search: [
        {
          searchfield: "branchid",
          searchvalue: branchId,
          criteria: "eq",
          datatype: "ObjectId",
        },
        {
          searchfield: "facilityids",
          searchvalue: facilityids,
          criteria: "in",
          datatype: "ObjectId",
        },
        {
          searchfield: "startdate",
          searchvalue: checkInDate,
          criteria: "eq",
          datatype: "date",
        },
        {
          searchfield: "enddate",
          searchvalue: checkOutDate,
          criteria: "eq",
          datatype: "date",
        },
      ],
    };
    return Axios.post("api/services/dailyavailability", body);
  };

export const getAllRoomList = async () => {
  const body = {
    search: [
      {
        searchfield: "branchid",
        searchvalue: localStorage.getItem("branchid"),
        criteria: "eq",
        datatype: "ObjectId",
      },
      {
        searchfield: "bookingtype",
        searchvalue: "DAILY",
        criteria: "eq",
        datatype: "text",
      },
      {
        searchfield: "status",
        searchvalue: "active",
        criteria: "eq",
      },
      {
        searchfield: "property.onlineavailibility",
        searchvalue: true,
        criteria: "eq",
        datatype: "boolean",
      },
    ],
  };
  return Axios.post("api/services/filter", body);
};
